import type { Metric } from 'web-vitals'

// コールバックを渡したときのみ web-vitals を動的 import して計測する（main バンドルには含めない）
const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  if (onPerfEntry) {
    import('web-vitals').then(({ onCLS, onINP, onLCP, onFCP, onTTFB }) => {
      onCLS(onPerfEntry)
      onINP(onPerfEntry)
      onLCP(onPerfEntry)
      onFCP(onPerfEntry)
      onTTFB(onPerfEntry)
    })
  }
}

export default reportWebVitals
